<template lang="pug">
main#configurator
  TransitionNavigate
    router-view(v-if="ready")
  Loader
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Loader from "./components/global/Loader.vue";
import TransitionNavigate from "./transitions/Navigate";
export default {
  name: "SVMicroCableConfigurator",
  components: {
    Loader,
    TransitionNavigate,
  },
  computed: {
    ...mapGetters(["ready"]),
  },
  methods: {
    ...mapMutations(["assignStaticValues"]),
    ...mapActions(["fetchData"]),
  },
  async created() {
    this.assignStaticValues({
      submitTo: this.$root.submitTo,
      relatedLength: parseInt(this.$root.relatedLength) || 0
    });
    await this.fetchData(this.$root.api);
  },
};
</script>

<style lang="scss">
html {
  font-size: $rootEM;
}

#configurator {
  margin: 0;
  padding: 0;
  font-size: $fontSizeBase;
  line-height: $lineHeightBase;
  font-family: $fontFamilyBase;
  font-weight: $fontWeightBase;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $fontColorBase;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  *:focus {
    outline: none;
  }
  *:focus-visible {
    outline: none; 
    #{$focusProperty}: $focusValue;
  }
}

@font-face {
  font-family: 'icomoon';
  src:
    url('../public/fonts/icomoon.ttf') format('truetype'),
    url('../public/fonts/icomoon.woff') format('woff'),
    url('../public/fonts/icomoon.svg#icomoon') format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="glyph"], [class*=" glyph"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.glyph-check:before {
  content: "\e906";
}
.glyph-add::before {
  content: "\e900";
}
.glyph-email::before {
  content: "\e902";
}
.glyph-pdf::before {
  content: "\e903";
}
.glyph-pencil::before {
  content: "\e904";
}
.glyph-print::before {
  content: "\e905";
}
.glyph-arrow-down::before {
  content: "\e901";
}
.glyph-remove::before {
  content: "\e914";
}

</style>
